import {
  GET_AREAS_FETCHING,
  GET_AREAS_SUCCESS,
  GET_AREAS_FAILURE,
} from '../actionTypes/areas'

const initialState = {
  error: null,
  data: null,
  isFetching: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_AREAS_FETCHING:
      return {
        ...state,
        isFetching: true,
      }
    case GET_AREAS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isFetching: false,
      }
    case GET_AREAS_FAILURE:
      return {
        ...state,
        error: action.failure,
        isFetching: false,
      }

    default:
      return state
  }
}
